import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isEqual } from "lodash";

import {getParam} from '../utils/utils';
import {getItem, listItems, listCodeLists} from '../utils/utilsCodeList';

import dsd from '../classes/clsDSD';

import * as PD from '../classes/pdStyle';

import Buffering from "../components/Buffering"; 

class SelectCodeListItem extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            renderState: null
        };

        this.dsd = new dsd();

        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount(){
        this.setup();
    }

    componentDidUpdate(prevProps, prevState){
        if (!isEqual(this.props, prevProps)){
            this.setup();
        }
    }

    setup(){

        let StateChange = {
            renderState: null,
            selectCodeList: false,
            label: "Item",
            idSelected: "",
            idCodeList: null,
            onChange: null,
        }

        StateChange.name = getParam('name', this.props);

        if (getParam('label', this.props)){
            StateChange.label = getParam('label', this.props);
        }

        StateChange.selectCodeList = getParam('selectCodeList', this.props);
        StateChange.idCodeList = getParam('idCodeList', this.props);
        StateChange.idSelected = getParam('value', this.props);

        StateChange.onChange = getParam('onChange', this.props);

        if (StateChange.selectCodeList){
            this.loadCodeLists();
        }

        if (StateChange.idCodeList){
            this.loadItems(StateChange.idCodeList);
        }

        if (StateChange.idSelected){
            this.loadSelectedItem(StateChange.idSelected);
        }

        this.setState(StateChange);
    }

    loadSelectedItem(idItem){

        if (!idItem){
            return;
        }

        this.setState({renderState: "loading"});

        const onLoad = (Item) => {
            const StateChange = {
                SelectedItem: Item,
                renderState: "loaded"
            };

            if (Item.CodeList){
                StateChange.idCodeList = Item.CodeList._id;
                this.loadItems(StateChange.idCodeList);
            }

            this.setState(StateChange);
        };

        const onFail = (error) => {
            this.setState({
                renderState: "failed",
                errorMessage: error.message || "Failed to load item"
            });
        };

        getItem(this.dsd, idItem, onLoad, onFail);
    }

    loadItems(idCodeList){

        if (!idCodeList){
            return;
        }

        this.setState({renderState: "loading"});

        const onLoad = (items) => {
            this.setState({
                Items: items,
                renderState: "loaded"
            });
        };

        const onError = (error) => {
            this.setState({
                renderState: "failed",
                errorMessage: error.message || "Failed to load items"
            });
        };

        listItems(this.dsd, {idCodeList: idCodeList}, onLoad, onError);
    }

    loadCodeLists(){

        this.setState({renderState: "loading"});

        const onLoad = (CodeLists) => {
            this.setState({
                CodeLists: CodeLists,
                renderState: "loaded"
            });
        };

        const onError = (error) => {
            this.setState({
                renderState: "failed",
                errorMessage: error.message || "Failed to load code lists"
            });
        };

        listCodeLists(this.dsd, {}, onLoad, onError);
    }

    handleChange(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        switch (FormFieldName){
            case "idCodeList":
                this.setState({"idCodeList": FormFieldValue});
                if (FormFieldValue){
                    this.loadItems(FormFieldValue);
                }
                break;
            default:
                let FormData = this.state.FormData;
                FormData[FormFieldName] = FormFieldValue;
                this.setState({"FormData": FormData});
                break;
        }
    }

    render() {

        switch (this.state.renderState){
            case "invalid":
            case "failed":
            case "denied":
                let Message = "An error has occured";
                if (this.state.errorMessage){
                    Message = this.state.errorMessage;
                }
                return <PD.ErrorBox>{Message}</PD.ErrorBox>
            case "loading":
                return <Buffering/>
            case "loaded":

                return(
                    <>

                        {this.state.selectCodeList && this.state.CodeLists &&
                            <PD.Select label='Select a Code List' name='idCodeList' onChange={this.handleChange} value={this.state.idCodeList}>
                                {
                                    this.state.CodeLists.map(
                                        (CodeList, pos) =>
                                            {
                                                return(
                                                    <option key={pos} value={CodeList._id}>{CodeList.name}</option>
                                                )
                                            }
                                    )
                                }
                            </PD.Select>
                        }

                        {this.state.Items &&
                            <PD.Select label={this.state.label} name={this.state.name} onChange={this.state.onChange} value={this.state.idSelected}>
                                {
                                    this.state.Items.map(
                                        (Item, pos) =>
                                            {
                                                return(
                                                    <option key={pos} value={Item._id}>{Item.code}{Item.label ? ` - ${Item.label}` : ''}</option>
                                                )
                                            }
                                    )
                                }
                            </PD.Select>
                        }

                    </>
                )
        }

        return null;
    }
}


export default function SelectCodeListItem_wrapper(props) {

    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <SelectCodeListItem {...props} navigation={navigation} location={location} params={params} />;
}
